import { useState } from "react";
import "../styles/FAQPage.css";

const FAQS = [
  {
    id: 1,
    category: "Visiting",
    q: "Where is Dickson Art Gallery located?",
    a: "We are located in Zanzibar, Tanzania. Please contact us via email or social media for the exact address and directions.",
  },
  {
    id: 2,
    category: "Visiting",
    q: "What are your opening hours?",
    a: "The gallery is open Monday to Saturday, 9:00 AM – 6:00 PM. We are closed on Sundays and public holidays unless a special event is scheduled.",
  },
  {
    id: 3,
    category: "Visiting",
    q: "Is entry to the gallery free?",
    a: "Yes, browsing the gallery is completely free. Some special exhibitions or events may have a small entry fee, which will be announced in advance.",
  },
  {
    id: 4,
    category: "Buying Art",
    q: "Can I purchase artworks online?",
    a: "Yes! You can browse and purchase artworks through our online shop. We offer local delivery in Zanzibar and can arrange international shipping on request.",
  },
  {
    id: 5,
    category: "Buying Art",
    q: "Do you accept commissions for custom artwork?",
    a: "Absolutely. Many of our artists accept commissions. Reach out to us with your ideas and we will connect you with the right artist for your vision.",
  },
  {
    id: 6,
    category: "Buying Art",
    q: "What payment methods do you accept?",
    a: "We accept cash (TZS and USD), mobile money (M-Pesa), and bank transfer. Card payments are available for online purchases.",
  },
  {
    id: 7,
    category: "Classroom",
    q: "Who can join the art workshops?",
    a: "Our workshops are open to everyone — beginners, hobbyists, and experienced artists alike. Each session specifies the recommended skill level.",
  },
  {
    id: 8,
    category: "Classroom",
    q: "How do I sign up for a workshop?",
    a: "Visit our Classroom page to browse upcoming sessions and register. You can also contact us directly by email to reserve your spot.",
  },
  {
    id: 9,
    category: "Classroom",
    q: "Are materials provided during workshops?",
    a: "Yes, all necessary art materials are included in the workshop fee unless stated otherwise in the session description.",
  },
  {
    id: 10,
    category: "Artists & Exhibitions",
    q: "How can I submit my artwork to be featured?",
    a: "We welcome local and international artists. Send us a portfolio or a selection of your work via email and our curatorial team will get back to you.",
  },
  {
    id: 11,
    category: "Artists & Exhibitions",
    q: "Do you host solo or group exhibitions?",
    a: "We host both! Solo exhibitions, group shows, and themed collections are all part of our annual calendar. Reach out early as slots fill up fast.",
  },
];

const CATEGORIES = ["All", ...Array.from(new Set(FAQS.map((f) => f.category)))];

function FAQItem({ item }) {
  const [open, setOpen] = useState(false);
  return (
    <div className={`faq-item ${open ? "faq-item--open" : ""}`}>
      <button className="faq-question" onClick={() => setOpen(!open)}>
        <span>{item.q}</span>
        <span className="faq-icon">{open ? "−" : "+"}</span>
      </button>
      {open && <div className="faq-answer">{item.a}</div>}
    </div>
  );
}

export default function FAQPage() {
  const [active, setActive] = useState("All");

  const filtered = active === "All" ? FAQS : FAQS.filter((f) => f.category === active);

  return (
    <div className="page faq-page">

      {/* ─── HEADER ─── */}
      <div className="faq-hero">
        <div className="section-ornament">
          <div className="section-ornament-line" />
          <span className="section-label">Help & Info</span>
          <div className="section-ornament-line" />
        </div>
        <h1 className="faq-title">
          Frequently Asked <em>Questions</em>
        </h1>
        <div className="section-rule" style={{ margin: "18px auto" }} />
        <p className="faq-sub">
          Everything you need to know about visiting, buying art, and joining our workshops.
        </p>
      </div>

      <div className="section faq-section">

        {/* ─── CATEGORY FILTERS ─── */}
        <div className="faq-filters">
          {CATEGORIES.map((cat) => (
            <button
              key={cat}
              className={`faq-filter-btn ${active === cat ? "faq-filter-btn--active" : ""}`}
              onClick={() => setActive(cat)}
            >
              {cat}
            </button>
          ))}
        </div>

        {/* ─── FAQ LIST ─── */}
        <div className="faq-list">
          {filtered.map((item) => (
            <FAQItem key={item.id} item={item} />
          ))}
        </div>

        {/* ─── STILL HAVE QUESTIONS ─── */}
        <div className="faq-contact">
          <div className="faq-contact-inner">
            <h3 className="faq-contact-title">Still have a question?</h3>
            <p className="faq-contact-desc">
              We're happy to help. Drop us a message and we'll get back to you shortly.
            </p>
            <a href="mailto:info@dicksonartgallery.com" className="btn btn-primary">
              Contact Us →
            </a>
          </div>
        </div>

      </div>
    </div>
  );
}